import { createTheme } from "@mui/material/styles";

const getTheme = (mode) =>
  createTheme({
    direction: "rtl",
    palette: {
      mode,
      primary: {
        main: "#f26322", // הכתום של שחל
        contrastText: "#fff",
      },
      secondary: {
        main: mode === "light" ? "#2c3e50" : "#90caf9",
      },
      background: {
        default: mode === "light" ? "#f5f5f5" : "#121212",
        paper: mode === "light" ? "#ffffff" : "#1e1e1e",
      },
      text: {
        primary: mode === "light" ? "#1a1a1a" : "#ffffff",
        secondary: mode === "light" ? "#666666" : "#b0b0b0",
      },
      divider:
        mode === "light" ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)",
    },
    typography: {
      fontFamily: "Assistant, Arial, sans-serif",
      h1: { fontWeight: 700 },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: (theme) => ({
          body: {
            transition: "background-color 0.3s ease, color 0.3s ease",
            "&::-webkit-scrollbar": {
              width: "24px", // עובי בולט יותר
              height: "14px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: theme.palette.background.default,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: theme.palette.primary.main,
              borderRadius: "8px",
              border: `3px solid ${theme.palette.background.default}`, // יוצר מראה "צף" נקי
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            },
            scrollbarColor: `${theme.palette.primary.main} ${theme.palette.background.default}`,
          },
          "*::-webkit-scrollbar": {
            width: "15px",
          },
          "*::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "*::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.mode === "light" ? "#ccc" : "#444",
            borderRadius: "10px",
            border: "2px solid transparent",
            backgroundClip: "content-box",
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        }),
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 20,
            textTransform: "none",
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          margin: "normal",
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: mode === "light" ? "#ffffff" : "#1e1e1e",
            backgroundImage: "none",
          },
        },
      },
    },
  });

export default getTheme;
